import { call, put, takeLeading } from 'redux-saga/effects';
import actions from './actions';
import errorActions from '../error/actions';
import dx_api from 'services/dxApi';
import { loadSortedClubs } from 'store/clubs/sagas';
import dxApi from 'services/dxApi';
import authUtils from '../../utils/auth';

const {
  Types: {
    GENERATE_HASH_REQUEST,
    GENERATE_ACCESS_TOKEN_REQUEST,
    GET_GEO_LOCATION_REQUEST,
    GET_GYM_HOURS_REQUEST,
  },
  Creators,
} = actions;

const {
  Creators: { setError },
} = errorActions;

export async function getGeolocation() {
  return new Promise(async (resolve, reject) => {
    if ('geolocation' in navigator) {
      try {
        const position = await new Promise((innerResolve, innerReject) => {
          navigator.geolocation.getCurrentPosition(innerResolve, innerReject);
        });
        resolve(position.coords);
      } catch (error) {
        resolve(null);
      }
    } else {
      resolve(null);
    }
  });
}

function* generateAccessToken() {
  try {
    let body = {
      clientId: process.env.REACT_APP_CLIENT_ID,
      clientSecret: process.env.REACT_APP_CLIENT_SECRET,
    };
    const token = yield call(dx_api.post, `/ols-account/generate-token`, body);
    if (token) {
      document.cookie = `new_ols_access_token=${token.data.data.accessToken}; max-age=${process.env.REACT_APP_COOKIE_TIME_TO_LIVE}`;
      const DXtoken = authUtils.getNewOlSToken();
      if (DXtoken) {
        dxApi.setAuthTokenToHeader(DXtoken);
        let clubs = { zip: null };
        yield call(loadSortedClubs, { clubs });
      }
    }
    yield put(Creators.generateAccessTokenSuccess(token.data));
  } catch (error) {
    yield put(Creators.generateAccessTokenFailure(error));
  }
}

function* generateHashSaga() {
  try {
    // Since we're now using the dxApi interceptor for signature generation,
    // we can directly call generateAccessToken
    yield call(generateAccessToken);
    yield put(Creators.generateHashSuccess('Success'));
  } catch (error) {
    yield put(Creators.generateHashFailure(error));
  }
}

function* getGymHours({ gymId }) {
  try {
    const { data } = yield call(
      dxApi.get,
      `/dashboard/home/get-working-hours?id=${gymId}`
    );
    if (!data.success) {
      yield put(Creators.getGymHoursFailure(data.message));
    } else {
      yield put(Creators.getGymHoursSuccess(data.data));
    }
  } catch (err) {
    yield put(Creators.getGymHoursFailure(err));
  }
}

export function* newOlsSaga() {
  yield takeLeading(GENERATE_HASH_REQUEST, generateHashSaga);
  yield takeLeading(GENERATE_ACCESS_TOKEN_REQUEST, generateAccessToken);
  yield takeLeading(GET_GEO_LOCATION_REQUEST, getGeolocation);
  yield takeLeading(GET_GYM_HOURS_REQUEST, getGymHours);
}
